import React from 'react'

import CurrentRegHolderWrapper from '../current-reg-holder'
import LeftNav from '../../left-nav'
import './layout.css'

const Layout = ({current_reg_holder, reg_holders, isEmbedded, children}) => (
  <CurrentRegHolderWrapper
    current_reg_holder={current_reg_holder}
    reg_holders={reg_holders}
  >
    {
      isEmbedded ?
        children :
        <div className="layout__wrapper">
          <nav className="layout__mainNav">
            <LeftNav
              current_reg_holder={current_reg_holder}
              reg_holders={reg_holders}
            />
          </nav>
          <main className="layout__content">
            {children}
          </main>
        </div>
    }
  </CurrentRegHolderWrapper>
)

export default Layout



// WEBPACK FOOTER //
// ./src/layout/authorised-layout/views/index.jsx